import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { BannerTypesDataService, BannerTypesColumnsService } from '../../../services';
import { BannerType, BannerTypesResult } from '../../../interfaces';

@Component({
  selector: 'app-banner-type-form',
  templateUrl: './banner-type-form.component.html',
  styleUrls: ['./banner-type-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class BannerTypeFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public bannerType: BannerType = {};
  public bannerTypeForm: FormGroup = new FormGroup({});
  public bannerTypes: BannerType[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private bannerTypesDataService: BannerTypesDataService,
    public bannerTypesColumnsService: BannerTypesColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'BannerTypeFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Banner Type - Edit');
        this.getBannerType(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.bannerType !== 'undefined') {
      this.bannerType = this.dynamicDialogConfig.data.bannerType;
    }
    if (typeof this.bannerType.id === 'undefined' || this.bannerType.id === null) {
      this.bannerType.id = null;
      this.bannerType.isPublished = false;
    }
    this.getBannerTypes();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'BannerTypeFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'BannerTypeFormComponent');
  }

  getBannerType(id: number): void {
    this.isLoading = true;
    this.bannerTypesDataService.getBannerType(id).subscribe((response: BannerType|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.bannerType = response;
        this.prepareFrom();
      }
    });
  }

  getBannerTypes(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.bannerTypes !== 'undefined' && this.dynamicDialogConfig.data.bannerTypes.length > 0) {
      this.bannerTypes = this.dynamicDialogConfig.data.bannerTypes;
      return;
    }
    this.bannerTypesDataService.getBannerTypes(this.parameters).subscribe((response: BannerTypesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.bannerTypes = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.bannerTypeForm = new FormGroup({
      id: new FormControl(this.bannerType.id, []),
      name: new FormControl(this.bannerType.name, [Validators.required, ]),
      slug: new FormControl(this.bannerType.slug, [Validators.required, ]),
      extensions: new FormControl(this.bannerType.extensions, [Validators.required, ]),
      mimeTypes: new FormControl(this.bannerType.mimeTypes, [Validators.required, ]),
      isPublished: new FormControl(this.bannerType.isPublished, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/banner-types']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.bannerTypeForm.controls).forEach((field: any) => {
        const control = this.bannerTypeForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.bannerTypeForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.bannerType = this.bannerTypeForm.value;
    this.disableSubmit = true;
    console.log('bannerType', this.bannerType);
    if (typeof this.bannerType.id !== 'undefined' && this.bannerType.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.bannerTypesDataService.updateBannerType(this.bannerType).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('BANNERTYPEUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('BANNERTYPENOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.bannerTypesDataService.addBannerType(this.bannerType).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('BANNERTYPECREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('BANNERTYPENOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-banner-type-form',
  templateUrl: './banner-type-form.component.html',
  styleUrls: ['./banner-type-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogBannerTypeFormComponent extends BannerTypeFormComponent {
}

